module.exports = __webpack_public_path__ + "static/img/22.936f8e13.jpg";